import { Get, Post } from "../server";

const baseUrl = process.env.VUE_APP_BASE_API

export function login(data) {
  const body = new URLSearchParams()
  Object.keys(data || {}).forEach(k => body.append(k, data[k]))
  return Post(baseUrl + "/report/auth", body)
}

// 仓库信息
export function getStashInfo() {
  return Get(baseUrl + "/report/depository_info");
}

// 队员信息
export function getTeamInfo() {
  return Get(baseUrl + "/report/team_info_v2");
}

// 申请单数据
export function getApplyOrderInfo() {
  return Get(baseUrl + "/report/apply_info");
}

// 任务数据
export function getQuestInfo() {
  return Get(baseUrl + "/report/task_info");
}

// 装备状态统计
export function getZCInfo() {
  return Get(baseUrl + "/report/zc_info");
}

// 指标信息
export function getIndicators() {
  return Get(baseUrl + "/report/indicators");
}

// 基础配置
export function getConfig() {
  return Get(baseUrl + "/report/config");
}

// 资产申请列表
export function getApplyList() {
  return Get(baseUrl + "/report/apply_list");
}

// 任务派发列表
export function getTaskList() {
  return Get(baseUrl + "/report/task_list");
}

// 获取设备列表
export function getDeviceList(data) {
  return Post(baseUrl + "/bus/get_device_list", data)
}

// 获取设备实时定位
export function getDeviceLocation(payload) {
  return Post(baseUrl + "/bus/get_locate", payload)
}

// 获取车辆轨迹
export function getPlyLocus(payload) {
  return Post(baseUrl + "/bus/get_ply_locus", payload)
}

export const biApi = {
  login,
  getStashInfo,
  getTeamInfo,
  getApplyOrderInfo,
  getQuestInfo,
  getZCInfo,
  getIndicators,
  getConfig,
  getApplyList,
  getTaskList,
  getDeviceList,
  getDeviceLocation,
  getPlyLocus
};
